import React from 'react';

import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  IconButton

} from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import parseDate from 'utils/parseDate';
import axios from 'axios';
import { ApiUrl } from 'features/api_url';
import { LinearProgress } from '@mui/material';
import { DeleteForever as DeleteIcon} from '@mui/icons-material';

const VisitorsCount = (props) => {

  const [visitorsData, setVisitorsData] = React.useState(null);

  const abortCtrl = new AbortController();
  const today = new Date();

  const thisYear = today.getFullYear();
  const thisMonth = today.getMonth()+1;


  React.useEffect(() => {

    const getData = async () => {
      await axios.get(ApiUrl + 'stats/getVistorsVisitsCount',{ month: thisMonth, year: thisYear},{ signal: abortCtrl.signal})
        .then(response => {

          if(response.data) {
            setVisitorsData(response.data);
            console.log('VISTORS DATA:', response.data);
          }

        })
        .catch((err) => console.log('ABORTING: ', err));
      
    }

    getData();

    return () => {
      console.log("UNMOUNTING VISITORS STATS");
      abortCtrl.abort();
    }

  },[]);

  const clearVisitors = async () => {
    await axios.delete(ApiUrl + 'stats/clearVisitors',{},{ signal: abortCtrl.signal})
      .then(response => {

        if(response.data) {
          console.log('VISTORS Clear:', response.data);
          setVisitorsData({minDate: parseDate(today),maxDate: parseDate(today), visits:0, visitors:0});
        }

      })
      .catch((err) => console.log('ABORTING: ', err));
    
  }
  const clearVisits = async () => {
    await axios.delete(ApiUrl + 'stats/clearVisits',{},{ signal: abortCtrl.signal})
      .then(response => {

        if(response.data) {
          console.log('VISITS Clear:', response.data);
          setVisitorsData({...visitorsData, visits:0});
        }

      })
      .catch((err) => console.log('ABORTING: ', err));
    
  }

  return (
    <>
    { visitorsData &&
      <Table>
        <TableBody>
        <TableRow>
            <TableCell><Typography component={'span'}><strong>From:</strong> { parseDate(visitorsData.minDate) } </Typography></TableCell>
            <TableCell><Typography component={'span'}><strong>To:</strong> { parseDate(visitorsData.maxDate) }</Typography></TableCell>
            
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography component={'span'}><strong>Visitors:</strong> { visitorsData.visitors }</Typography>
              <IconButton 
                  color="warning" 
                  size="small" 
                  disabled={visitorsData.visitors > 0 ? false : true}
                  onClick={clearVisitors} 
                  title={'Clear'}

                  >
                <DeleteIcon />
              </IconButton>
            </TableCell>
            <TableCell>
              <Typography component={'span'}><strong>Page Views:</strong> { visitorsData.visits }</Typography>
              <IconButton 
                  color="warning" 
                  size="small" 
                  disabled={visitorsData.visits > 0 ? false : true}
                  onClick={clearVisits} 
                  title={'Clear'}

                  >
                <DeleteIcon />
              </IconButton>
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    }
    { !visitorsData && 
    <>
      <Typography component={'p'}>Loading Visitors stats...</Typography>
    </>
    
    }
    </>
    
  );
}
export default VisitorsCount;
